import React from 'react'
// components
import ApiTokensTable from 'components/PageComponents/Settings/Api/ApiTokens/components/Table'
import ApiSettingsContent from 'components/PageComponents/Settings/Api/ApiTokens/components/Content'
import CreateAPITokenButton from 'components/CTAs/CreateAPIToken'
// context
import { ApiTokensPageContext } from 'containers/ApiTokens/layers/API'

interface Props {
  tab: number
  setTab: (value: number) => void
}

const ApiTokensTab: React.FC<Props> = ({ tab, setTab }) => {
  const { isLoading } = React.useContext(ApiTokensPageContext)

  const handleSetTab = (_: React.SyntheticEvent, value: number) => setTab(value)

  return (
    <ApiSettingsContent tab={tab} onTabChange={handleSetTab} isLoading={isLoading} cta={<CreateAPITokenButton />}>
      <ApiTokensTable />
    </ApiSettingsContent>
  )
}

export default ApiTokensTab
